import getUserPermissions from '../jwt/getUserPermissions';

/**
 * Verifica sincrónicamente si el JWT del usuario contiene el UUID de módulo dado.
 * Retorna true si el uuid es falsy (feature sin protección).
 */
export function hasModuleAccess(uuid: string): boolean {
  if (!uuid) return true;
  const permissions = getUserPermissions();
  const modules = permissions?.accessKeyModules || [];
  return modules.some((m: any) => m.id === uuid);
}
